import { render, staticRenderFns } from "./RegisterAlianza.vue?vue&type=template&id=087b9a84"
import script from "./RegisterAlianza.vue?vue&type=script&lang=js"
export * from "./RegisterAlianza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports